import { createSlice } from "@reduxjs/toolkit";

const initialState = { data: {}, isOpen: false };

const businessWinnerDetailsSlice = createSlice({
  name: "business_winner_details",
  initialState,
  reducers: {
    openModal(state, action) {
      state.data = action.payload;
      state.isOpen = true;
    },
    closeModal(state) {
      state.data = {};
      state.isOpen = false;
    },
  },
});

export const businessWinnerDetailsActions = businessWinnerDetailsSlice.actions;
export default businessWinnerDetailsSlice;
